import script from "./sw-form-viewer.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-form-viewer.vue?vue&type=script&setup=true&lang=js"

import "./sw-form-viewer.vue?vue&type=style&index=0&id=77c46f24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c46f24"]])

export default __exports__